<template>
  <Layout>
    <List :ships="filteredShips" />
    <template #sidebar-left>
      <FilterSidebar />
    </template>
  </Layout>
</template>
<script>
import axios from 'axios';
import Layout from '@/Theme/Layouts/LayoutSidebarLeft.vue';
import List from '@/Modules/List/Components/List.vue';
import FilterSidebar from '@/Modules/Filters/Components/FilterSidebar.vue';
import env from '@/env';

const axiosInstance = axios.create({
  baseURL: env.api.baseURL,
  withCredentials: env.api.baseURLrequestCredentials,
  headers: {
    common: {
      'Ocp-Apim-Subscription-Key': env.api.OcpApimSubscriptionKey,
    },
  },
});

export default {
  name: 'ViewMain',
  components: {
    FilterSidebar,
    Layout,
    List,
  },
  data() {
    return {
      ships: [],
    };
  },
  computed: {
    filteredShips() {
      return this.ships.filter((ship) => {
        if (!ship.approved) {
          return false;
        }
        let filter = this.$store.state.filters.multi;
        if (filter) {
          let name = false;
          let imo = false;
          let ucrn = false;
          filter = filter.toLowerCase();
          if (ship.vesselName) {
            name = ship.vesselName.toLowerCase().indexOf(filter) !== -1;
          }
          if (ship.imo) {
            imo = ship.imo.toLowerCase().indexOf(filter) !== -1;
          }
          if (ship.ucrn) {
            ucrn = ship.ucrn.toLowerCase().indexOf(filter) !== -1;
          }
          return name || imo || ucrn;
        }
        return true;
      });
    },
  },
  mounted() {
    this.fetchPage();
    setInterval(() => {
      this.refreshShips();
    }, env.api.refreshInterval);
  },
  methods: {
    fetchPage() {
      let query = '';
      const params = {
        PageSize: 200,
        Page: this.$store.state.page,
        HapPlichtig: '',
      };
      const date = new Date();
      const date2 = new Date();
      date2.setMonth(date2.getMonth() - env.api.numberOfMonths);
      params.From = date2.toISOString();
      params.Until = date.toISOString();
      Object.keys(params).forEach((key) => {
        query += query ? '&' : '?';
        query += `${key}=${params[key]}`;
      });
      axiosInstance
        .get(`ArrivedHapVessels${query}`)
        .then((response) => {
          this.ships = this.ships.concat(response.data.results);
          if (response.data.nextPage) {
            this.$store.commit('setPage', response.data.nextPage);
            return this.fetchPage();
          }
          this.$store.commit('setLoading', false);
          return response;
        })
        .catch(() => {
          this.$store.commit('setErrored', true);
          this.$store.commit('setLoading', false);
        });
    },
    refreshShips() {
      this.ships = [];
      this.$store.commit('setLoading', true);
      this.$store.commit('setPage', 1);
      this.fetchPage();
    },
  },
};
</script>
